import { c as _c } from "react/compiler-runtime";
import { VirtualizedGrid } from "@components/virtualized/virtualized-grid";
import { FaroTableBulkActions } from "@components/common/faro-table/faro-table-bulk-actions";
import { MembersMobileViewItem } from "@pages/members/members-mobile-view-item";
import { SkeletonMemberListItemCard } from "@components/common/mobile/skeleton-member-list-item-card";
import { useAppSelector } from "@store/store-helper";
import { selectedSdbCompanySelector } from "@store/sdb-company/sdb-company-selector";
import { bulkActionNameSelector, selectedEntitiesSelector } from "@store/table/table-selector";
import { FaroTableEmptyPage } from "@components/common/faro-table/faro-table-empty-page";
import { useSetMemberTableType } from "@hooks/table/use-set-member-table-type";
/**
 * Generic mobile list component for displaying members with virtualization,
 * selection, and bulk actions.
 *
 * Encapsulates the common pattern of VirtualizedGrid with MembersMobileViewItem
 * rendering and FaroTableBulkActions, with customization points for different contexts.
 */
export function MemberMobileList(t0) {
  const $ = _c(24);
  const {
    members,
    isLoading,
    bulkActionButtons,
    tableSubject,
    menuItems,
    group,
    selectedProject,
    sortBy,
    loadMoreItems
  } = t0;
  useSetMemberTableType(tableSubject);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("members");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedEntities = useAppSelector(t1);
  const selectedSdbCompany = useAppSelector(selectedSdbCompanySelector);
  const bulkActionName = useAppSelector(bulkActionNameSelector);
  let t2;
  if ($[1] !== members) {
    t2 = members.map(_temp);
    $[1] = members;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const allMemberIds = t2;
  if (!selectedSdbCompany) {
    return null;
  }
  if (!isLoading && !members.length && bulkActionName === null) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <FaroTableEmptyPage />;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] !== group || $[5] !== menuItems || $[6] !== selectedProject || $[7] !== selectedSdbCompany.id || $[8] !== tableSubject) {
    t3 = member_0 => <MembersMobileViewItem key={member_0.identity} member={member_0} companyId={selectedSdbCompany.id} tableSubject={tableSubject} menuItems={menuItems} group={group} selectedProject={selectedProject} />;
    $[4] = group;
    $[5] = menuItems;
    $[6] = selectedProject;
    $[7] = selectedSdbCompany.id;
    $[8] = tableSubject;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isLoading || $[11] !== loadMoreItems || $[12] !== members || $[13] !== sortBy || $[14] !== t3) {
    t4 = <VirtualizedGrid key={sortBy} items={members} isLoading={isLoading} renderSkeletonItem={_temp2} estimateSize={112} shouldMeasureRowHeight={true} renderItem={t3} loadMoreItems={loadMoreItems} />;
    $[10] = isLoading;
    $[11] = loadMoreItems;
    $[12] = members;
    $[13] = sortBy;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== allMemberIds || $[17] !== bulkActionButtons || $[18] !== isLoading || $[19] !== selectedEntities.length) {
    t5 = <FaroTableBulkActions bulkActionsButtons={bulkActionButtons} numberOfSelectedRows={selectedEntities.length} isLoading={isLoading} allRowIds={allMemberIds} />;
    $[16] = allMemberIds;
    $[17] = bulkActionButtons;
    $[18] = isLoading;
    $[19] = selectedEntities.length;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  let t6;
  if ($[21] !== t4 || $[22] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  return t6;
}
function _temp2(index) {
  return <SkeletonMemberListItemCard key={`skeleton-${index}`} />;
}
function _temp(member) {
  return member.identity;
}